import { URL_HOME, URL_PARAM_REDIRECT } from "@/constants/routes";

/**
 * Можно ли вернуть пользователя по этому пути после входа.
 * Только внутренний путь: `//evil.com`, `/\evil.com` и абсолютные URL отклоняются (open redirect).
 */
export function isSafeRedirectPath(path: string | null | undefined): path is string {
    if (!path || !path.startsWith("/")) return false;
    if (path.startsWith("//") || path.startsWith("/\\")) return false;
    // Управляющие символы (перевод строки, таб) браузер вырезает из URL: `/\t/evil.com` -> `//evil.com`.
    return !Array.from(path).some((char) => char.charCodeAt(0) < 0x20 || char === "\u007f");
}

/** Добавляет к `href` параметр возврата, если путь безопасен; иначе возвращает `href` как есть. */
export function withRedirectParam(href: string, redirectPath: string | null | undefined): string {
    if (!isSafeRedirectPath(redirectPath)) return href;

    const [path = href, query = ""] = href.split("?", 2);
    const params = new URLSearchParams(query);
    params.set(URL_PARAM_REDIRECT, redirectPath);
    return `${path}?${params.toString()}`;
}

/** Куда перейти после входа: безопасный путь из параметра возврата или `fallback`. */
export function resolveRedirectPath(redirectPath: string | null | undefined, fallback = URL_HOME): string {
    return isSafeRedirectPath(redirectPath) ? redirectPath : fallback;
}
